// extracted by mini-css-extract-plugin
export default {"button":"TqwqM0bU0zGDqyk4fYaU","tooltip":"CDFkI0EQkzkKeyWmqtIg"};